// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__28gB-","notes":"Notes_notes__3SK6P"};